import { Box, Typography } from "@mui/material";
import { DisplayBoxBase } from "../../../../components/shared/StyledComponents";
import { IAdvisor } from "../../../../types";
import { AdvisorProfileSummary } from "../../../advisor/components/AdvisorProfileSummary";
import { AdvisorCompany } from "../../../advisor/components/AdvisorCompany";
import { AdvisorProfileImage } from "../../../advisor/components/AdvisorProfileImage";
import { Link } from "react-router-dom";
import { CompanyAdvisorLink } from "../CompanyAdvisorLink";
import { ChartScatter } from "lucide-react";

export const NewAdvisors = ({ advisors }: { advisors: IAdvisor[] }) => {
    const sortedAdvisors = advisors.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    });

    // Helper to get a longer description
    const getDescription = (advisor: IAdvisor) => {
        // Try highlights_json (prefer full highlight text if available)
        const highlights = JSON.parse(advisor.highlights_json || "{}")?.highlights;
        if (Array.isArray(highlights) && highlights[0]) {
            return highlights[0];
        }
        // No fallback, as there is no bio field
        return "";
    };

    return (
        <Box sx={{ width: "100%", height: "100%", minHeight: 0, display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%", marginBottom: "1rem" }}>
                <Typography variant="body1" sx={{ fontWeight: 600, marginBottom: 0 }}><ChartScatter size={16} style={{marginBottom: "2px"}}/> New Advisors</Typography>
                <Typography variant="body2" sx={{ color: "#7b8a99", fontWeight: 600 }}>
                    <Link to="/c/activity">
                        See all
                    </Link>
                </Typography>
            </Box>
            <DisplayBoxBase
                className="white column"
                sx={{
                    gap: 3,
                    width: "100%",
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                }}
            >
                {sortedAdvisors.slice(0, 3).map((advisor) => (
                    <CompanyAdvisorLink key={advisor.uuid} uuid={advisor.uuid}>
                    <Box
                        key={advisor.id}
                        sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "flex-start", gap: "1rem", width: "100%" }}
                    >
                        <Box sx={{ minWidth: 0, flex: '0 0 auto' }}>
                            <AdvisorProfileImage advisor={advisor} size="small" />
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "flex-start", gap: "0.5rem", width: "100%" }}>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%" }}>
                                <AdvisorProfileSummary advisor={advisor} showCompany={false} showImage={false} />
                                <AdvisorCompany advisor={advisor} size="small" style="right" />
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
                                <Typography
                                    variant="body2"
                                    sx={{ color: '#7b8a99', fontWeight: 400 }}
                                >
                                    {getDescription(advisor)}
                                </Typography>
                            </Box>
                            </Box>
                        </Box>
                    </CompanyAdvisorLink>
                ))}
            </DisplayBoxBase>
        </Box>
    );
};